import { render, staticRenderFns } from "@/clickbuy/purchase/views/sales-view/sales-view.pug?vue&type=template&id=d8fdeb0c&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/purchase/views/sales-view/sales-view.scss?vue&type=style&index=0&id=d8fdeb0c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fdeb0c",
  null
  
)

export default component.exports